import { gql } from '@apollo/client';

export const GET_COMPANY_JOBS = gql`
  query GetCompanyJobs($jobType: JobType, $statuses: [JobStatusEnum!]) {
    companyJobs(job_type: $jobType, statuses: $statuses) {
      jobs {
        # Common Job interface fields
        job_id
        job_type
        status
        progress_percentage
        processed_count
        estimated_count
        error_message
        created_at
        started_at
        updated_at
        # Pool-specific fields via inline fragment
        ... on PoolCreationJob {
          pool_name
          asset_class
          has_filters
          loan_count
        }
        # Offering-specific fields via inline fragment
        ... on OfferingCreationJob {
          offering_name
          pool_id
        }
      }
    }
  }
`;
